export function formatNumber(num: number) {
  if (num >= 10 ** 5) {
    // Convert to lakhs
    return (num / 10 ** 5).toFixed(1) + 'L';
  } else if (num >= 10 ** 3) {
    // Convert to thousands
    return (num / 10 ** 3).toFixed(1) + 'k';
  } else {
    // Numbers less than 1000 remain unchanged
    return num.toString();
  }
}
